<template>
    <client-page class="app--main">
        <sub-visual tit="공지사항" sc="공지사항 서브텍스트가 들어갑니다." bg="/images/sub/visual/sv-notice.jpg" />
        <section class="section">
            <v-container>
                <!-- 1. 게시판 리스트: 베이직 스킨 -->
                <notification-list v-if="!$route.params._notification"></notification-list>
                <notification-view v-else></notification-view>
                <!-- 2. 게시판 작성: 베이직 스킨 -->
                <!-- <board-basic-input></board-basic-input> -->
                <!-- 3. 게시판 뷰: 베이직 스킨 -->
                <!-- <board-basic-view></board-basic-view> -->
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import NotificationList from "@/components/client/center/notifications/notification-list.vue";
import NotificationView from "@/components/client/center/notifications/notification-view.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";

export default {
    components: {
        SubVisual,
        ClientPage,
        NotificationList,
        NotificationView,
    },
    mounted() {
        this.reroute();
    },
    watch: {
        "$route.path"() {
            this.reroute();
        },
    },
    methods: {
        async reroute() {
            let path = "/center/notice";
            if (!this.$route.path.includes(path)) this.$router.replace({ path });
        },
    },
};
</script>
